"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function validateSchema(obj, schema, options) {
  if (options === void 0) {
    options = {
      stripUnknown: true
    };
  }

  var validatorResult = schema.validate(obj, options);

  if (validatorResult.error || validatorResult.value === undefined) {
    throw validatorResult.error;
  }

  var value = validatorResult.value;

  if (value === undefined) {
    throw new Error(JSON.stringify(validatorResult.error));
  }

  return validatorResult.value;
}

exports.default = validateSchema;